// Turbo
import { Turbo, cable } from "@hotwired/turbo-rails"
import consumer from "./channels/consumer"
import { installTurboProgressGuard } from "./turbo_progress_guard"
import "./storefront_native"

cable.setConsumer(consumer)
installTurboProgressGuard(Turbo)

// Bootstrap
import * as bootstrap from "./bootstrap_runtime"
window.bootstrap = bootstrap

import { showToast } from "utils/toast"
window.showToast = showToast

import $ from "jquery"
window.$ = window.jQuery = $
import select2 from "select2"
select2($)


import "./button_feedback"

// Stimulus controllers
import { application } from './controllers/application'
import "./controllers/index"

import Sortable from '@stimulus-components/sortable'
application.register('sortable', Sortable)

import HwComboboxController from "@josefarias/hotwire_combobox"
// application.register("hw-combobox", HwComboboxController)

import HwComboboxMonkeyPatch from "./controllers/hw_combobox_monkey_patch"
application.register("hw-combobox", HwComboboxMonkeyPatch)

// ActiveStorage
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

// Custom Turbo Stream Actions
Turbo.StreamActions.addClass = function () {
    this.targetElements.forEach((target) => {
        if (!target.classList.contains(this.templateContent.textContent)) {
            target.classList.add(this.templateContent.textContent);
        }
    });
};

Turbo.StreamActions.removeClass = function () {
    this.targetElements.forEach((target) => {
        if (target.classList.contains(this.templateContent.textContent)) {
            target.classList.remove(this.templateContent.textContent);
        }
    });
};

// messages panel lazy-load
document.addEventListener("turbo:load", () => {
    const frame = document.querySelector("#messages_panel")
    const src = frame?.dataset.src
    if (frame && src && !frame.getAttribute("src")) {
        requestAnimationFrame(() => {
            if (!frame.getAttribute("src")) {
                frame.setAttribute("src", src)
            }
        })
    }
})

// ActionCable channels
import "./channels"
import "./react_components.js"
